// DMK — Monogram Weasley:
// 1) Convert Yarn Color fieldset (Horizon variant picker) into a compact dropdown
// 2) Add Letter Color dropdown + Letter Text input as line item properties
(function() {
  var HANDLE = 'monogram-weasley-jumper-letter-magic-gift-handmade-custom-wool-sweater-pullover-christmas-for-him-her';
  var COLORS = [
    'Burgundy (Red)', 'Pink', 'Brown', 'Blue', 'Beige', 'Ocher', 'Navy Blue', 'Black',
    'Army Green', 'Purple', 'Christmas Green', 'Christmas Red', 'Sugar Pink', 'Acid',
    'Gold', 'Orange', 'Dark Brown', 'White'
  ];

  function onWeasleyPage() {
    return location.pathname.indexOf('/products/' + HANDLE) === 0;
  }

  // Precisely find the Yarn Color fieldset by matching its <legend> exactly
  function findYarnColorFieldset() {
    var fieldsets = document.querySelectorAll('variant-picker fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      var lg = fieldsets[i].querySelector('legend');
      if (lg && lg.textContent.trim().toLowerCase() === 'yarn color') {
        return fieldsets[i];
      }
    }
    return null;
  }

  function transformYarnColorToDropdown() {
    if (!onWeasleyPage()) return;
    var fs = findYarnColorFieldset();
    if (!fs) return;
    // Already transformed?
    if (fs.previousSibling && fs.previousSibling.classList && fs.previousSibling.classList.contains('dmk-yarn-color-wrap')) return;

    var inputs = Array.from(fs.querySelectorAll('input[type="radio"]'));
    if (!inputs.length) return;
    var selectedValue = null;
    var values = [];
    inputs.forEach(function(inp) {
      var v = inp.value;
      if (v && values.indexOf(v) === -1) values.push(v);
      if (inp.checked) selectedValue = v;
    });

    // Build wrapper
    var wrap = document.createElement('div');
    wrap.className = 'dmk-yarn-color-wrap dmk-weasley-field';
    var lbl = document.createElement('label');
    lbl.className = 'dmk-weasley-label';
    lbl.htmlFor = 'dmk-yarn-color-select';
    lbl.textContent = 'Yarn Color';

    var sel = document.createElement('select');
    sel.id = 'dmk-yarn-color-select';
    sel.className = 'dmk-weasley-select';
    var ph = document.createElement('option');
    ph.value = ''; ph.textContent = 'Choose a yarn color'; ph.disabled = true;
    if (!selectedValue) ph.selected = true;
    sel.appendChild(ph);
    values.forEach(function(v) {
      var o = document.createElement('option');
      o.value = v; o.textContent = v;
      if (v === selectedValue) o.selected = true;
      sel.appendChild(o);
    });

    sel.addEventListener('change', function() {
      var target = inputs.find(function(inp) { return inp.value === sel.value; });
      if (!target) return;
      // Prefer clicking the associated label (some variant-picker components rely on click event on label/link)
      var lb = target.closest('label') || fs.querySelector('label[for="' + target.id + '"]');
      if (lb) {
        lb.click();
      } else {
        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
        target.dispatchEvent(new Event('input', { bubbles: true }));
        target.click();
      }
    });

    wrap.appendChild(lbl);
    wrap.appendChild(sel);

    // Insert the wrapper right before the fieldset, then hide the fieldset
    fs.parentNode.insertBefore(wrap, fs);
    fs.style.display = 'none';
  }

  function injectLetterFields() {
    if (!onWeasleyPage()) return;
    if (document.getElementById('dmk-weasley-block')) return;
    var form = document.querySelector('form[action*="/cart/add"]') || document.querySelector('product-form form') || document.querySelector('form.product-form');
    if (!form) return;

    var wrap = document.createElement('div');
    wrap.id = 'dmk-weasley-block';
    wrap.className = 'dmk-weasley-block';

    var lcField = document.createElement('div');
    lcField.className = 'dmk-weasley-field';
    var lcLabel = document.createElement('label');
    lcLabel.className = 'dmk-weasley-label';
    lcLabel.htmlFor = 'dmk-letter-color';
    lcLabel.textContent = 'Letter Color';
    var lcSelect = document.createElement('select');
    lcSelect.id = 'dmk-letter-color';
    lcSelect.className = 'dmk-weasley-select';
    lcSelect.name = 'properties[Letter Color]';
    lcSelect.required = true;
    var lcPh = document.createElement('option');
    lcPh.value = ''; lcPh.textContent = 'Pick a letter color'; lcPh.disabled = true; lcPh.selected = true;
    lcSelect.appendChild(lcPh);
    COLORS.forEach(function(c) { var o = document.createElement('option'); o.value = c; o.textContent = c; lcSelect.appendChild(o); });
    lcField.appendChild(lcLabel); lcField.appendChild(lcSelect);

    var ltField = document.createElement('div');
    ltField.className = 'dmk-weasley-field';
    var ltLabel = document.createElement('label');
    ltLabel.className = 'dmk-weasley-label';
    ltLabel.htmlFor = 'dmk-letter-text';
    ltLabel.textContent = 'Letter';
    var ltInput = document.createElement('input');
    ltInput.id = 'dmk-letter-text';
    ltInput.className = 'dmk-weasley-input';
    ltInput.type = 'text';
    ltInput.name = 'properties[Letter]';
    ltInput.maxLength = 3;
    ltInput.placeholder = 'e.g. R';
    ltInput.autocomplete = 'off';
    ltInput.required = true;
    ltInput.addEventListener('input', function() { this.value = this.value.toUpperCase(); });
    ltField.appendChild(ltLabel); ltField.appendChild(ltInput);

    var hint = document.createElement('p');
    hint.className = 'dmk-weasley-hint';
    hint.textContent = 'Pick a color for the letter and type the letter (1–3 characters).';

    wrap.appendChild(lcField);
    wrap.appendChild(ltField);
    wrap.appendChild(hint);

    var atcBtn = form.querySelector('[type="submit"], button.product-form__submit, button[name="add"]');
    if (atcBtn && atcBtn.parentElement) {
      atcBtn.parentElement.insertBefore(wrap, atcBtn);
    } else {
      form.appendChild(wrap);
    }
  }

  function run() {
    transformYarnColorToDropdown();
    injectLetterFields();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  var mo = new MutationObserver(function() { run(); });
  mo.observe(document.body, { childList: true, subtree: true });
})();
